<template>
    <div id="ProgramList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div v-if="PMVal != undefined">
            <div class="bg-white data-table p-0">
                <vue-good-table
                    ref="listPMUnitDetailTable"
                    mode="remote"
                    title="Program"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-select-all="onSelectAll"
                    @on-selected-rows-change="selectionChanged"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :select-options="{
                        enabled: false,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                    }"
                    :search-options="{
                    enabled: false,
                    }">

                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                        {{props.formattedRow[props.column.field]}}
                        </div>
                    </template>
                </vue-good-table>
            </div>
        </div>
        <div v-else id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> PM Unit Detail With History</div>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- Button for Clear Cache
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                    <!-- <router-link v-if="canAddProgram" class="btn btn-primary pull-right" v-bind:to="{name: 'ProgramCreate'}" > <i class="fp-add"> </i> Add</router-link> -->
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content program-list">
                        <data-table-filter-config :moduleName="'PMUnitDetailList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'PMUnitDetailList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listPMUnitDetailTable"
                                      mode="remote"
                                      title="Program"
                                      @on-page-change="onPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-select-all="onSelectAll"
                                      @on-selected-rows-change="selectionChanged"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: true,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                        enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <!-- <div v-if="props.column.field == 'action'">
                                                  <template v-if="canUpdateProgram">
                                                      <router-link title="Edit Program" class="fp-edit mr-3" v-bind:to="{name: 'ProgramEdit',params:{id:props.row.id}}"></router-link>
                                                  </template>
                                                  <router-link title="Activity" class="fp-contracts" v-bind:to="{name: 'ProgramActivityCreate',params:{id:props.row.id}}"></router-link>
                                              </div>
                                              <div v-if="props.column.field == 'name'">
                                                      <router-link title="View Program Asset" class="color-blue" v-bind:to="{name: 'ProgramAssetMapperList',params:{id:props.row.id}}">{{props.row.name}}</router-link>
                                              </div>
                                              <div v-else> -->
                                                  {{props.formattedRow[props.column.field]}}
                                              <!-- </div> -->
                                          </div>
                                      </template>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "./../event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "PMUnitDetailList",
        metaInfo() {
            return {title: "PM Unit Detail List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            PMVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'PM Unit',
                    field: 'unit_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'PM Program',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'PM Description',
                    field: 'description',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                },
                {
                    label: 'Program Status',
                    field: 'status',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems:[{text:'Active',value:'active'},{text:'Expired',value:'expired'}],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'PM Due Date',
                    field: 'due_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"custom_date",
                    sortable:true
                },
                {
                    label: 'PM Completion Date',
                    field: 'completion_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"custom_date",
                    sortable:true
                },
                {
                    label: 'PM Work order',
                    field: 'work_order_no',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'PM WO Reading',
                    field: 'wo_read',
                    filterable: false,
                    fpFieldType:"integer",
                    type:"number",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'LTD Reading',
                    field: 'ltd_reading',
                    filterable: true,
                    fpFieldType:"integer",
                    type:'number',
                    hidden:false,
                },
                {
                    label: 'UOM',
                    field: 'uom',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Prior Due Date',
                    field: 'prior_due_dt',
                    filterable: false,
                    fpFieldType:"custom_date",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Prior Completion Date',
                    field: 'prior_completion_dt',
                    filterable: false,
                    fpFieldType:"custom_date",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Prior Work Order',
                    field: 'prior_wo',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Days Overdue',
                    field: 'days_overdue',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'PM Work Roaster',
                    field: 'pm_roaster',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Equipment Type',
                    field: 'truck_type',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'PM Category Code',
                    field: 'category',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'PM Type',
                    field: 'type',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Facility',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Region',
                    field: 'region',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Customer Number',
                    field: 'cust_code',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Customer Name',
                    field: 'cust_name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Pool',
                    field: 'pool',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Serial Number',
                    field: 'vin',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                },
                {
                    label: 'Ownership Sts',
                    field: 'ownership',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Ownership Description',
                    field: 'own_description',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                },
            ],
            rows: [],
            action: '',
            totalRecords: 0,
            term_value: false,
            loading:false,
            batchProcess:0,
            batchNum:"",
            // canUpdateProgram:false,
            // canAddProgram:false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'pm_unit_detail_report') {
                            self.cantAccessPage = true;
                        }
                        // if (permissions[i].name == 'delete_Program') {
                        //     self.term_value = true;
                        // }
                        // if (permissions[i].name == 'add_program') {
                        //     self.canAddProgram = true;
                        //     self.canUpdateProgram = true;
                        // }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            if ( self.PMVal == undefined ) {
                // self.getPermissions();
            }else{
                self.PMVal = "loadList";
                self.loadList();
            }
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listPMUnitDetailTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var vehId = 0;
                if( self.PMVal == 'dontLoadList' ){
                    return;
                }else{
                    if (self.PMVal != undefined && self.PMVal == 'loadList'){
                        vehId = self.$route.params.id;
                    }
                }
                var selectedRows = [];
                var data = this.$refs['listPMUnitDetailTable'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listPMUnitDetailTable'].selectedRows[i].id)
                }


                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action: self.action,
                    selectedAll:self.serverParams.selectedAll,
                    selectedRows:selectedRows,
                    vehicle_id:vehId
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/pm-unit-detail-report/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {

                           if ( self.action == "export" ||  self.action == "export_queue") {

                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {

                                  if ( self.action == "export" ) {

                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";

                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);

                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }

                              }

                              self.action = "list";
                              // self.loadList();
                              return;
                            } else {
                              self.rows = data.content.result.row;
                              self.totalRecords = data.content.totalRecords;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'program-list')
                    }
                });
            },

            addAsset:function(flag){
                var self = this;
                var data = self.$refs['listProgramTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listProgramTable'].selectedRows[i].id)
                }
                if(use.length > 1){
                    self.$swal('','Please Select Atmost One Program','info');
                    return;
                }

                if (flag == 'asset'){
                    self.$router.push("/asset/list?from=program&pr="+use[0]);
                }
                if (flag == 'group'){
                    self.$router.push("/assetgroup/list?from=program&pr="+use[0]);
                }
            },

            // ProgramDelete() {
            //     var data = this.$refs['listProgramTable'].selectedRows;
            //     var self = this;
            //     var use = [];
            //     for (var i = 0; i < data.length; i++) {
            //         use.push(this.$refs['listProgramTable'].selectedRows[i].id)
            //     }

            //     if (confirm('Are you sure that you want to delete this Program? ')) {
            //         self.loading = true;
            //         $("#deleteProgramBtn").val("Deleting ...");
            //         $.ajax({
            //             url: process.env.ROOT_API + "/program/delete",
            //             type: "POST",
            //             data: 'id=' + use,
            //             headers: {
            //                 'Accept': 'application/json',
            //                 "Authorization": "Bearer " + localStorage.getItem("tkn"),
            //                 'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            //                 "Cache-Control": "no-cache"
            //             },
            //             dataType: 'json',
            //             success: function (data) {
            //                 self.loading = false;
            //                 setTimeout(function () {
            //                 $(".alert-success").removeClass("show");
            //                     $(".alert-success").addClass("hide");
            //                 }, 10000);
            //                 setTimeout(function () {
            //                     $("#deleteProgramBtn").val("Delete");
            //                 }, 10000);
            //                 if (data.code == '200') {
            //                     self.rows = data.content.row;
            //                     self.totalRecords = data.content.totalRecords;
            //                     self.loadList();
            //                 }
            //             },
            //             error: function (jqXHR, exception) {
            //                 self.loading = false;
            //                 self.generateStatusCodeMessage(jqXHR,true,'Program-delete')
            //             }
            //         });
            //     }
            // }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/reports/PMUnitDetailReport.vue